module.exports = __webpack_public_path__ + "img/pointRose.814bc8a3.svg";